var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 1.5H4.5C3.255 1.5 2.25 2.4975 2.25 3.7275V11.91C2.25 13.14 3.255 14.1375 4.5 14.1375H5.07C5.67 14.1375 6.24 14.37 6.66 14.79L7.9425 16.0575C8.5275 16.635 9.48 16.635 10.065 16.0575L11.3475 14.79C11.7675 14.37 12.345 14.1375 12.9375 14.1375H13.5C14.745 14.1375 15.75 13.14 15.75 11.91V3.7275C15.75 2.4975 14.745 1.5 13.5 1.5ZM12.51 7.875L11.6325 10.545C11.52 10.9875 11.0475 11.3475 10.5675 11.3475H9.18C8.94 11.3475 8.6025 11.265 8.4525 11.115L7.35 10.2525C7.3275 10.7325 7.11 10.935 6.5775 10.935H6.2175C5.6625 10.935 5.4375 10.7175 5.4375 10.1925V6.615C5.4375 6.09 5.6625 5.8725 6.2175 5.8725H6.585C7.14 5.8725 7.365 6.09 7.365 6.615V6.885L8.82 4.725C8.97 4.4925 9.3525 4.3275 9.675 4.455C10.0275 4.575 10.2525 4.965 10.1775 5.31L9.9975 6.48C9.975 6.5775 9.9975 6.6825 10.065 6.75C10.125 6.8175 10.215 6.8625 10.3125 6.8625H11.775C12.06 6.8625 12.3 6.975 12.4425 7.1775C12.5775 7.3725 12.6 7.62 12.51 7.875Z",
    fill: "#16140C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon02);
export default __webpack_public_path__ + "static/media/like-icon02.866cc6d5ad649fe690197594eb9f32fd.svg";
export { ForwardRef as ReactComponent };